// v-live, beside v-model on a text field that filters as you type.
//
// Android keyboards (Gboard on Fennec and Chrome) type each word as a
// composition, and v-model ignores input until it ends (at a space or a
// pick from the suggestions). This clears v-model's "composing" mark on
// every input, before its own listener reads it: listeners in the capture
// phase run first on the field itself.
const live = (event) => {
  event.target.composing = false
}

export default {
  created(el) {
    el.addEventListener('input', live, { capture: true })
  },
  beforeUnmount(el) {
    el.removeEventListener('input', live, { capture: true })
  },
}
